<template>
  <div class="m-progress">
    <div class="m-progress-text" v-if="showInfo">
      <div class="progressVal">{{ progress >= 100 ? 100 : progress }}%</div>
      <div>LOAOING. . . . . .</div>
    </div>
    <div class="m-progress-outer">
      <div class="m-progress-inner">
        <div
          :class="['u-progress-bg', { 'u-success-bg': progress >= 100 }]"
          :style="`width: ${
            progress >= 100 ? 100 : progress
          }%; height: ${strokeWidth}px;`"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Progress",
  props: {
    progress: {
      // 当前进度
      type: Number,
      default: 36,
    },
    strokeWidth: {
      // 进度条线的宽度
      type: Number,
      default: 8,
    },
    showInfo: {
      // 是否显示进度数值或状态图标
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
@font-face {
  /* 标题字体 */
  font-family: TitleFamily;
  src: url('https://zhuoke211025-news.oss-cn-shenzhen.aliyuncs.com/Liosystem/fonts/TitleFamily.ttf')format("opentype");  ;
}
.m-progress {
  border: 1px solid #ffffff;
  padding: 4px 12px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  .m-progress-text {
    margin-bottom: 2px;
    display: flex;

    div {
      font-size: 26px;
      font-family: TitleFamily;
      color: #ffffff;
    }

    .progressVal {
      color: #42f3ff;
      margin-right: 12px;
    }
  }

  .m-progress-outer {
    width: 100%;
    .m-progress-inner {
      display: inline-block;
      width: 100%;
      background: rgba(0, 0, 0, 0.7) rgba(0, 145, 255, 0.2);
      border: 1px solid #ffffff;
      .u-progress-bg {
        // background: linear-gradient(to right, rgb(0, 51, 64), rgb(0, 201, 255));
        background: url("./images/Loaoing.png") no-repeat 0 0;
        background-size: 100% 100%;
        transition: all 0.3s cubic-bezier(0.08, 0.82, 0.17, 1);
      }
      .u-success-bg {
        background: url("./images/Loaoing.png") no-repeat 0 0;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
